// @unocss-include
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon, PwaInstallTrigger } from '@a-type/ui';
export function InstallButton(props) {
    return (_jsx(PwaInstallTrigger, { asChild: true, children: _jsx(Button, Object.assign({ emphasis: "ghost", size: "small" }, props, { children: props.children || (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "arrowDown" }), _jsx("span", { children: "Install app" })] })) })) }));
}
//# sourceMappingURL=InstallButton.js.map